// extracted by mini-css-extract-plugin
export default {"post_page":"PostPage_post_page__XMdE-"};